import { HeroSection } from "components/hero-section";
import { FeaturedCampaigns } from "components/featured-campaigns";
import { StatsSection } from "components/stats-section";
import { CTASection } from "components/cta-section";
import RaisePage from "./RaisePage";

export default function HomePage() {
  return (
    <>
      {/* <HeroSection />
      <FeaturedCampaigns />
      <StatsSection />
      <CTASection /> */}
      <RaisePage />
    </>);

}